var map = {
	"./digi-wall.jpg": 3289,
	"./hero-10.png": 4304,
	"./hero-11.png": 9900,
	"./hero-13.png": 7277,
	"./hero-14.png": 4790,
	"./hero-2.png": 7453,
	"./hero-3.png": 5477,
	"./hero-5.png": 341,
	"./hero-8.png": 9854,
	"./hero-img-1.png": 2247,
	"./hero-img-10.png": 8268,
	"./hero-img-11.png": 9061,
	"./hero-img-12.png": 4405,
	"./hero-img-13.png": 370,
	"./hero-img-14.png": 8707,
	"./hero-img-2.png": 1550,
	"./hero-img-3.png": 2444,
	"./hero-img-4.png": 1319,
	"./hero-img-5.png": 415,
	"./hero-img-6.png": 1036,
	"./hero-img-7.png": 2679,
	"./hero-img-8.png": 8136,
	"./hero-img-9.png": 9949,
	"./logo-2.png": 148,
	"./logo.png": 8221,
	"./product-1.webp": 9651,
	"./product-10.webp": 5527,
	"./product-11.webp": 3569,
	"./product-12.webp": 7624,
	"./product-13.webp": 9175,
	"./product-14.webp": 9524,
	"./product-15.webp": 6012,
	"./product-16.webp": 9914,
	"./product-17.webp": 1509,
	"./product-18.webp": 4326,
	"./product-19.webp": 9118,
	"./product-2.webp": 699,
	"./product-20.webp": 2102,
	"./product-21.webp": 892,
	"./product-22.webp": 4859,
	"./product-23.webp": 834,
	"./product-24.webp": 7369,
	"./product-25.webp": 3328,
	"./product-26.webp": 2868,
	"./product-27.webp": 6183,
	"./product-28.webp": 4501,
	"./product-29.webp": 9163,
	"./product-3.webp": 6736,
	"./product-30.webp": 5499,
	"./product-31.webp": 8788,
	"./product-32.webp": 7179,
	"./product-33.webp": 2280,
	"./product-34.webp": 2178,
	"./product-35.webp": 7293,
	"./product-36.webp": 6156,
	"./product-37.webp": 5485,
	"./product-38.webp": 9210,
	"./product-39.webp": 6701,
	"./product-4.webp": 2503,
	"./product-40.webp": 271,
	"./product-41.webp": 139,
	"./product-42.webp": 6530,
	"./product-43.webp": 6395,
	"./product-44.webp": 8105,
	"./product-45.webp": 6945,
	"./product-46.webp": 397,
	"./product-47.webp": 2185,
	"./product-48.webp": 718,
	"./product-49.webp": 2703,
	"./product-5.webp": 4114,
	"./product-50.webp": 9156,
	"./product-51.webp": 2243,
	"./product-52.webp": 6571,
	"./product-53.webp": 8945,
	"./product-54.webp": 6581,
	"./product-55.webp": 9418,
	"./product-56.webp": 8564,
	"./product-57.webp": 5358,
	"./product-58.webp": 4595,
	"./product-59.webp": 6319,
	"./product-6.webp": 410,
	"./product-60.webp": 6458,
	"./product-61.webp": 2203,
	"./product-62.webp": 1247,
	"./product-63.webp": 6733,
	"./product-64.webp": 4766,
	"./product-65.webp": 5466,
	"./product-66.webp": 1567,
	"./product-67.webp": 3557,
	"./product-68.webp": 9842,
	"./product-69.webp": 2410,
	"./product-7.webp": 573,
	"./product-70.jpg": 9753,
	"./product-71.webp": 6641,
	"./product-72.webp": 2710,
	"./product-73.jpg": 912,
	"./product-74.jpg": 9128,
	"./product-75.jpg": 7632,
	"./product-76.jpg": 3432,
	"./product-77.webp": 2916,
	"./product-78.jpg": 9784,
	"./product-79.webp": 9644,
	"./product-8.webp": 93,
	"./product-80.jpg": 5773,
	"./product-81.jpg": 4955,
	"./product-81.webp": 6119,
	"./product-82.jpg": 6152,
	"./product-83.webp": 1328,
	"./product-84.png": 3690,
	"./product-85.jpg": 3293,
	"./product-86.jpg": 6213,
	"./product-9.webp": 5261,
	"./slider-image.png": 5035,
	"./slider-img-1.webp": 5422,
	"./slider-img-10.webp": 5750,
	"./slider-img-11.webp": 5888,
	"./slider-img-12.webp": 1305,
	"./slider-img-13.webp": 5097,
	"./slider-img-15.webp": 6245,
	"./slider-img-16.webp": 1200,
	"./slider-img-17.webp": 5332,
	"./slider-img-18.webp": 4646,
	"./slider-img-19.webp": 2700,
	"./slider-img-20.webp": 8854,
	"./slider-img-23.jpg": 2419,
	"./slider-img-24.webp": 7302,
	"./whatsappQr.png": 4845
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1068;